import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { TWButton } from '../../../../components/ui';

// A component cannot catch an error thrown by its own render — a boundary
// defined inside ConnectFinance's own return statement never even gets built
// if something throws before that return runs. This has to live one level
// up, here, wrapping just the <ConnectFinance> mount inside
// connect-settlement.js rather than the whole settlement block — the
// "Settlement" heading and its Show/Hide toggle sit above this and stay
// standing regardless. Its own small component, not
// account-sections-boundary.js (the settings surface's own equivalent, gone
// with settings/payments) or connect-support-boundary.js (the same fix on
// the support surface), and never imports either module's copy.
const ConnectSettlementBoundary = ({ retryLabel = 'Refresh', children }) => (
  <ErrorBoundary
    fallbackRender={() => (
      <div className="flex flex-wrap items-center justify-between gap-3 py-4">
        <p className="text-sm text-slate-500 dark:text-slate-400">
          This section could not load. Refresh the page to try again.
        </p>
        <TWButton
          size="sm"
          label={retryLabel}
          onClick={() => window.location.reload()}
          aria-label={retryLabel + ' settlement'}
        />
      </div>
    )}
  >
    {children}
  </ErrorBoundary>
);

export default ConnectSettlementBoundary;
